import { PREPARING } from '@/config'
import { BaseAPIClient } from '@/utils/utils.http'
import store from '@/store/store.examiner'

export default class ExaminerAPIClient extends BaseAPIClient {
  getStore () {
    return store
  }

  login = (email, password) =>
    this.client.post('/auth/login/', { email, password })

  refreshToken = token => {
    console.debug('refresh call made')
    return this.client.post('/auth/token/refresh/', { refresh: token })
  }

  changePassword = (payload) =>
    this.client.post('/auth/password/change/', payload)

  getUser = () =>
    this.client.get('/auth/user/')

  getCompanyUsers = companyId =>
    this.client.get(`/company/${companyId}/users/`)

  getExamList = () =>
    this.client.get('/exam/')

  getExam = id =>
    this.client.get(`/exam/${id}/`)

  getExamStudents = examId =>
    this.client.get(`/exam/${examId}/students/`)

  getExamCommission = examId =>
    this.client.get(`/exam/${examId}/commissionmembers/`)

  getExamPapers = examId =>
    this.client.get(`/exam/${examId}/papers/`)

  createNewExam = exam =>
    this.client.post('/exam/', exam)

  createNewExaminer = examiner =>
    this.client.post('/register/', examiner)

  editExam = (examId, exam) =>
    this.client.put(`/exam/${examId}/`, exam)

  uploadPapers = (examId, papers) =>
    this.client.post(`/exam/${examId}/papers/`, papers)

  uploadStudents = (examId, students) =>
    this.client.post(`/exam/${examId}/students/`, students)

  deleteExam = examId =>
    this.client.delete(`/exam/${examId}/`)

  sendStudentStatus = (studentId, status) =>
    this.client.patch(`/studentsession/${studentId}/`, { status })

  sendStudentPaper = (studentId, paperId) =>
    this.client.patch(`/studentsession/${studentId}/`,
      { examination_paper: paperId, status: PREPARING })
}
